import { Commit, ActionTree, Dispatch } from 'vuex';
import { State } from './application.store';

const actions: ActionTree<State, any> = {};

export default actions;
